<script lang="ts" setup>
  import { Menu } from '@bt/design-system'
  import { storeToRefs } from 'pinia'
  import { useAppStore } from '@/stores'
  import { useBreakpoints } from '@/composables/useBreakpoints'

  const appStore = useAppStore()
  const { isDesktop } = useBreakpoints()
  const { menuData } = storeToRefs(appStore)
  const emit = defineEmits(['pageChange'])
</script>

<template>
  <div class="layout-sidebar">
    <div class="sidebar-content content-wrapper">
      <div
        v-if="isDesktop"
        class="sidebar"
      >
        <Menu
          :items="menuData"
          class="menu"
          width="full"
          @change="emit('pageChange', $event)"
        />
      </div>
      <slot />
    </div>
  </div>
</template>

<style lang="scss" scoped>
  @import '@/assets/styles/common.scss';

  .layout-sidebar {
    display: flex;
    margin: 0 rem(16) rem(56);
    flex-direction: column;

    @include desktop-up {
      margin: 0 auto rem(56);
      width: 100%;
    }

    .sidebar-content {
      display: flex;

      @include tablet-up {
        width: 100%;
      }

      .sidebar {
        width: 100%;

        @include tablet-up {
          max-width: rem(380);
        }

        .menu {
          position: sticky;
          top: rem(10);
        }
      }
    }
  }
</style>
